import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingVideo } from './types/Listing';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingVideo[]>('GET', `${APIV2_URL}/listing/${listingId}/videos`);
